export const HITWORDS_CHANGED = `HITWORDS_CHANGED`

export function hitwordsChanged(hitwords) {
  return {
    type: HITWORDS_CHANGED,
    hitwords,
  }
}
